// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-2TMZh";
var _3 = "big-1ro0z";
var _4 = "recommended-Ax6A6";
var _5 = "selected-ZWCGN";
var _6 = "disabled-3pHIP";
var _7 = "block__top-2AuGl";
var _8 = "block__bottom-3j5X8";
var _9 = "wrapper-UkRM3";
var _a = "button-3vP7e";
var _b = "small-3T8Ho";
var _c = "notification-14kjK";
export { _1 as "__esModule", _2 as "root", _3 as "big", _4 as "recommended", _5 as "selected", _6 as "disabled", _7 as "block__top", _8 as "block__bottom", _9 as "wrapper", _a as "button", _b as "small", _c as "notification" }
export default { "__esModule": _1, "root": _2, "big": _3, "recommended": _4, "selected": _5, "disabled": _6, "block__top": _7, "block__bottom": _8, "wrapper": _9, "button": _a, "small": _b, "notification": _c }
